export const TITLE_FONT_SIZE = { xs: 12, sm: 16 };
